import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { applicationContexts } from '../../data/content';
export function Applications() {
  const [active, setActive] = useState(0);
  const reduceMotion = useReducedMotion();
  const current = applicationContexts[active];
  const CurrentIcon = current.icon;
  return <section className="bg-white py-12 lg:py-20" aria-labelledby="applications-title" data-id="element-171" data-mp="14alu89ih7uem">
      <div className="mx-auto max-w-4xl px-5" data-id="element-172" data-mp="gkrixwdt2dwh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-173" data-mp="bok9htm7ak9s">
          <h2 id="applications-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-174" data-mp="blof2f9kadq3">
            ¿Dónde podés aplicar <span className="text-brand-600" data-id="element-175" data-mp="knnu5210n7qe">estos recursos?</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-176" data-mp="3t3h9hdjm2d5v">
            Algunos ejemplos de posibles ámbitos de trabajo, según tu formación y los requisitos de cada lugar.
          </p>
        </div>

        <p className="mt-6 text-center text-xs font-semibold text-ink-soft lg:mt-8" data-id="element-177" data-mp="1bvoxuiw02o4p">Tocá cada espacio para ver cómo aplicarlo</p>

        <div role="tablist" aria-label="Espacios de aplicación" className="mt-3 flex flex-wrap justify-center gap-1.5 sm:gap-2" data-id="element-178" data-mp="1gtgufq7layf8">
          {applicationContexts.map((c, i) => {
          const Icon = c.icon;
          const selected = i === active;
          return <button key={c.title} type="button" role="tab" id={`app-tab-${i}`} aria-selected={selected} aria-controls="app-panel" onClick={() => setActive(i)} className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-[13px] font-semibold leading-tight transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-600/30 sm:text-sm ${selected ? 'bg-brand-600 text-white' : 'bg-brand-50 text-ink hover:bg-brand-100'}`} data-id="element-179" data-mp="sz5pvwwxn69q" data-mpi={i}>
                <Icon className={`h-4 w-4 shrink-0 ${selected ? 'text-white' : 'text-brand-600'}`} aria-hidden="true" data-id="element-180" data-mp="e86apff03x99" />
                {c.title}
              </button>;
        })}
        </div>

        <div id="app-panel" role="tabpanel" aria-labelledby={`app-tab-${active}`} aria-live="polite" className="mx-auto mt-4 max-w-2xl overflow-hidden rounded-2xl bg-brand-950 text-white" data-id="element-181" data-mp="o7n8lao0h6uo">
          <AnimatePresence mode="wait" initial={false} data-id="element-182" data-mp="9a4qus9r3twq">
            <motion.div key={active} initial={reduceMotion ? false : {
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={reduceMotion ? {
            opacity: 0
          } : {
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 p-4 sm:items-center sm:p-5" data-id="element-183" data-mp="9bpl0gs5lau2">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sun text-ink" data-id="element-184" data-mp="2yr34tq3qtbgu">
                <CurrentIcon className="h-5 w-5" aria-hidden="true" data-id="element-185" data-mp="2ov01wi12h8su" />
              </span>
              <div className="min-w-0" data-id="element-186" data-mp="2ot5dgtql6yk0">
                <h3 className="font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-187" data-mp="2tt9z0y6cqjh3">{current.title}</h3>
                <p className="mt-0.5 text-[13px] leading-snug text-brand-100 sm:text-sm" data-id="element-188" data-mp="3hkyuuoidtq2s">{current.description}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg font-extrabold uppercase leading-snug tracking-tight text-brand-950 sm:text-2xl" data-id="element-189" data-mp="37kogh0km2cm1">
          Preparate para ampliar los espacios donde podés <span className="text-brand-600" data-id="element-190" data-mp="1w4rfgdzi028g">aplicar tus herramientas.</span>
        </p>
      </div>
    </section>;
}